import { ref, reactive, watch } from 'vue'
import { defineRule, validate } from 'vee-validate'
import {
  required,
  fio,
  phone,
  inn,
  passport,
  email,
  date,
  datePast,
  vin,
  ogrn,
  digits,
  imei,
} from '@/hooks/validators'

// Регистрируем правила в глобальном реестре vee-validate (один раз на модуль).
const validatorList = {
  required,
  fio,
  phone,
  inn,
  passport,
  email,
  date,
  date_past: datePast,
  vin,
  ogrn,
  digits,
  imei,
}

for (const [name, rule] of Object.entries(validatorList)) {
  defineRule(name, rule)
}


export function useField(field = {}) {
  const valid = ref(true)
  const value = ref(field.value)
  const errors = reactive({})
  const tochted = ref(false)

    const namedRules = (field.validators || []).filter((key) => typeof key === 'string' && validatorList[key])
  const fnRules = (field.validators || []).filter((key) => typeof key === 'function')

  const reasign = async (val) => {
    if (!namedRules.length && !fnRules.length) {
      valid.value = true
      return
    }
    const results = await Promise.all(
      namedRules.map((key) => validate(val, key)),
    )
    let allValid = true
    namedRules.forEach((key, i) => {
      const message = results[i].valid ? '' : (results[i].errors[0] || 'Некорректное значение')
      errors[key] = message
      if (!results[i].valid) allValid = false
    })
    fnRules.forEach((fn, index) => {
      const result = fn(val)
      const ok = result === true
      errors[fn.name || `fn${index}`] = ok ? '' : (result || 'Некорректное значение')
      if (!ok) allValid = false
    })
    valid.value = allValid
  }

  watch(value, reasign)
  reasign(value.value)

  return { valid, value, errors, tochted, blur: () => (tochted.value = true), reasign }
}
